import React from 'react';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/ui';
import { useAppStore } from '@/shared/lib/store';
import { logger } from '@/shared/lib';
import { SidebarContext } from './layout-context';
import { SidebarWrapper } from '@/widgets/sidebar';
import { NavbarWrapper } from '@/widgets/navbar';

export const MainLayout: React.FC = () => {
  const { sidebarCollapsed, setSidebarCollapsed } = useAppStore();


  const handleToggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <SidebarContext.Provider
      value={{
        collapsed: sidebarCollapsed,
        setCollapsed: handleToggleSidebar,
      }}
    >
      <div className="flex font-inter bg-background text-foreground min-h-screen">
        <SidebarWrapper />
        <NavbarWrapper>
          <ErrorBoundary
            showDetails={import.meta.env.DEV}
            onError={(error, errorInfo) => {
              // Additional error logging could go here
              // For example, sending to error tracking service
              logger.error('Page Error:', error, errorInfo);
            }}
          >
            <Outlet />
          </ErrorBoundary>
        </NavbarWrapper>
      </div>
    </SidebarContext.Provider>
  );
};